module.exports = __webpack_public_path__ + "img/fenetre.8bc0236.svg";